export default {
      id: "i-smi-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-smi",
      toString: function () {
        return this.url;
      }
    }